var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loading-overlay'),_c('error-modal'),_c('navbar'),_c('off-canvas'),_c('div',{staticClass:"app-layout"},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('router-view')],1),_c('generic-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }